import React from 'react';
import { UseFormRegister, FieldValues, DeepMap, FieldError } from 'react-hook-form';
import EditButton from '../EditButton';

type Props = {
  name: string;
  label: string;
  value: string;
  defaultSelected?: boolean;
  showEditBtn: boolean;
  editable: boolean;
  validationObj?: any; // TODO: add types

  register: UseFormRegister<FieldValues>;
  errors: DeepMap<FieldValues, FieldError>;
  formData: any;
  returnToStep?: (name: string) => void;
  // I need to update formData immediately
  // so I can get the conditional fields to show when they should
  onChange: any;
}

/**
 * A TextInput component
 * @param props
 */
let RadioButton = (props: Props) => {
  // TODO: react-hook-form probably has a better way of passing refs around
  // but this seems to work for now...
  const { register, errors } = props;

  const clickEditBtn = (e: React.MouseEvent) => {
    // Only has one if added for reviewMode
    if (props.returnToStep) props.returnToStep(props.name);
  };

  // Existing value > defaultSelected > false
  const defaultValue = props.formData[props.name]
    ? props.formData[props.name] === props.value
    : props.defaultSelected ?? false;

  // console.log(`${props.name}:${props.value} is checked?`, defaultValue);

  const renderEditable = () => {
    const dom = <>
      <div className="RadioButton">
        <label>
          <input {...register(props.name, props.validationObj)}
            name={props.name}
            type="radio"
            value={props.value}
            defaultChecked={defaultValue}
            // disabled={!props.editable}
            className={errors[props.name] ? 'parsley-error' : undefined}
            aria-describedby={errors[props.name] ? `${props.name}-errors` : undefined}
            // TODO: onChange doesn't work, is onClick versatile enough?
            onClick={props.onChange}
          />
          {`${props.label}`}
        </label>
        {/* NOTE: no validation because it goes in the Step, so it only displays once
        { props.inRadioGroup ? null : generateErrorMarkup(errors, props.name) }
        */}
      </div>
    </>;

    return dom;
  };

  const renderNonEditable = () => {
    const dom = defaultValue
    ? // If radio is selected
      <div className="Fieldset--forced-single-col">
        <div className="RadioButton ">
          <span>{props.label}</span>
          { props.showEditBtn ? <EditButton onClick={clickEditBtn}/> : null }
        </div>
      </div>
    : // If radio not selected
      null;

    return dom;
  };

  return (
    <>
      {props.editable
      ? // Editable version
        renderEditable()
      : // Non-editable version
        renderNonEditable()
      }
    </>
  );
};

export default RadioButton;
